/* eslint-disable global-require */
module.exports = ['homepage.faq.m1', 'homepage.faq.m2', 'homepage.faq.m3', 'homepage.faq.m4', 'homepage.faq.m5', 'homepage.faq.m6', 'homepage.faq.m7'];
